import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

export default function ProjectProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/projects/latest`);
        const data = await res.json();
        setProjects(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching projects:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <section id="projects" className="section-dark">
      <div className="shell">
        <div className="section-head">
          <div>
            <p className="eyebrow">Projects</p>
            <h2 className="section-title">
              <span class="featured-text">
                Featured <em>projects.</em>
              </span>
            </h2>
          </div>
          <Link to="/ViewProjects" className="link-arrow">
            All Projects
          </Link>
        </div>

        {loading ? (
          <div className="loader-wrap">
            <div className="loader" />
          </div>
        ) : projects.length === 0 ? (
          <p className="empty-state">No research projects published yet.</p>
        ) : (
          <div className="card-grid">
            {projects.map((p) => (
              <Link
                key={p._id}
                to={`/projects/${encodeURIComponent(p.name)}`}
                className="card"
              >
                <div className="card-thumb">
                  {p.thumbnail && <img src={p.thumbnail} alt={p.name} />}
                </div>
                <div className="card-body">
                  <p className="card-meta">
                    {new Date(p.date).toLocaleDateString("en-US", {
                      month: "long",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </p>
                  <h3 className="card-title">{p.name}</h3>
                  <p className="card-excerpt">{p.description}</p>
                  <p className="card-cta">View Research Project</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
